/**
 * @generated SignedSource<<3b409110ec9abdada60d7855ccaa41b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TicketLinkType = "related" | "child" | "project" | "forecast_task" | "%future added value";
export type TicketStatus = "open" | "in_progress" | "waiting_on_customer" | "resolved" | "closed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RelatedTab_ticket$data = {
  readonly id: string;
  readonly links: ReadonlyArray<{
    readonly id: string;
    readonly linkType: TicketLinkType;
    readonly createdAt: string;
    readonly targetTicket: {
      readonly id: string;
      readonly number: number;
      readonly subject: string;
      readonly status: TicketStatus;
      readonly assignee: {
        readonly " $fragmentSpreads": FragmentRefs<"ticketingPerson_person">;
      } | null;
    } | null;
    readonly targetProject: {
      readonly id: string;
      readonly name: string;
      readonly color: string | null;
    } | null;
    readonly creator: {
      readonly " $fragmentSpreads": FragmentRefs<"ticketingPerson_person">;
    } | null;
  }>;
  readonly " $fragmentType": "RelatedTab_ticket";
};
export type RelatedTab_ticket$key = {
  readonly " $data"?: RelatedTab_ticket$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedTab_ticket">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "ticketingPerson_person"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelatedTab_ticket",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketLink",
      "kind": "LinkedField",
      "name": "links",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TicketLinkTarget",
          "kind": "LinkedField",
          "name": "targetTicket",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "number",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectLinkTarget",
          "kind": "LinkedField",
          "name": "targetProject",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Ticket",
  "abstractKey": null
};
})();

(node as any).hash = "a01c7ca2159cf2a275106990f8b13e06";

export default node;
